export default __webpack_public_path__ + "static/ae_game_banner-d9e943f1f6875495620a74ddc4fa0bc4.webp";